/**
 * App header with title and sync status.
 */

import { SyncIndicator } from './SyncStatusBar';

interface HeaderProps {
  title?: string;
}

export function Header({ title = 'My Tasks' }: HeaderProps) {
  return (
    <header className="flex-none sticky top-0 z-20 bg-surface/95 backdrop-blur-sm border-b border-rule safe-top">
      <div className="flex items-center justify-between h-14 px-4">
        {/* Logo / Title */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-accent flex items-center justify-center">
            <svg
              className="w-4 h-4 text-white"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 4h12M2 8h8M2 12h10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h1 className="text-lg font-semibold text-ink">{title}</h1>
        </div>

        {/* Sync indicator */}
        <div className="flex items-center gap-2">
          <SyncIndicator />
        </div>
      </div>
    </header>
  );
}
